import { types } from 'mobx-state-tree';
export const ListPagerModel = types.model({
    pagesStart: types.optional(types.number, 1),
    pagesEnd: types.optional(types.number, 0),
    currentPage: types.optional(types.number, 1),
    totalPages: types.optional(types.number, 0)
}).actions(self => {

    const setCurrentPage = (pageIndex: number): void => {
        self.currentPage = pageIndex;
    }

    return {
        setCurrentPage
    }
})